import { Stack, StackProps, styled } from '@mui/material';

import { generateClasses } from '../../../../../../../utils/helper';

export const questionOptionClasses = generateClasses('QuestionOption', [
  'richTextEditor',
  'richTextEditorBody',
  'richTextEditorBodySkeleton',
  'richTextEditorErrorMessage',
  'richTextEditorToolbar',
  'action',
  'actionIcon',
]);

export const Root = styled((props: StackProps) => <Stack direction="row" {...props} />)(({ theme }) => ({
  borderRadius: 8,
  overflow: 'hidden',
}));

export const RichTextEditorWrapper = styled((props: StackProps) => (
  <Stack direction="row" alignItems="center" {...props} />
))(({ theme }) => ({
  border: `0.5px solid ${theme.palette.grey[300]}`,
  borderTopRightRadius: 8,
  borderBottomRightRadius: 8,
  [`& .${questionOptionClasses.richTextEditor}`]: {
    flex: 1,
    border: 'none',
    borderRadius: 0,
  },
  [`& .${questionOptionClasses.richTextEditorBody}`]: {
    margin: theme.spacing(1.5, 1),
    border: `0.5px solid ${theme.palette.grey[300]}`,
    borderRadius: 4,
  },
  [`& .${questionOptionClasses.richTextEditorBodySkeleton}`]: {
    width: 'unset !important',
    padding: theme.spacing(5),
  },
  [`& .${questionOptionClasses.richTextEditorErrorMessage}`]: {
    margin: theme.spacing(-2, 1, 0),
  },
  [`& .${questionOptionClasses.richTextEditorToolbar}`]: {
    paddingTop: 0,
  },
}));

export const Actions = styled((props: StackProps) => (
  <Stack direction="row" alignItems="center" gap={0.5} {...props} />
))(({ theme }) => ({
  alignSelf: 'flex-start',
  padding: theme.spacing(1, 1, 1, 0),
  margin: theme.spacing(1.5, 0),
  [`& .${questionOptionClasses.action}`]: {
    height: 32,
    aspectRatio: '1',
    [`& .${questionOptionClasses.actionIcon}`]: {
      fontSize: theme.typography.pxToRem(20),
      '& > svg': {
        fontSize: theme.typography.pxToRem(20),
      },
    },
  },
}));
